import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUsersThree = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.625 14.473c2.434.5 3.325 2.118 3.325 3.47M18.084 6.207a2.749 2.749 0 0 1 .117 5.192M5.541 20c0-2.11 1.665-4.734 6.458-4.734s6.459 2.605 6.459 4.715"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.126 8.125a4.125 4.125 0 1 1-8.25 0 4.125 4.125 0 0 1 8.25 0"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.375 14.473c-2.434.5-3.325 2.118-3.325 3.47M5.916 6.207a2.749 2.749 0 0 0-.117 5.192"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUsersThree);
export default ForwardRef;
